import { useOAIMutation, useOAIQuery } from '~/hooks/reactQuery';
import type { CART_TYPE } from '~/hooks/useCartTypeParam';

export const useUserCoupons = (variables: Record<string, unknown> = {}) => {
  const { data } = useOAIQuery({
    queryKey: '/api/market-place/v1/buyer-coupon',
    variables,
  });
  return data || [];
};

export const useUserCouponCount = () => {
  const { data } = useOAIQuery({
    queryKey: '/api/market-place/v1/buyer-coupon/count',
  });

  return data || 0;
};

export const useCheckoutCoupons = (cartType: CART_TYPE) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/shopping-cart/checkout/coupon',
    variables: {
      cartType,
    },
  });
};

export const useCurrentCouponName = ({
  buyerCouponId,
}: {
  buyerCouponId: number;
}) => {
  const { data } = useOAIQuery({
    queryKey: '/api/market-place/v1/buyer-coupon/{buyerCouponId}',
    variables: {
      buyerCouponId,
    },
    queryOptions: {
      enabled: !Number.isNaN(buyerCouponId),
    },
  });

  return data;
};

export const useDownloadedCouponsQuery = (
  couponIds: number[],
  enabled = true,
) => {
  const { data, ...props } = useOAIQuery({
    queryKey: '/api/market-place/v2/coupon/download',
    variables: {
      couponIds,
    },
    queryOptions: {
      keepPreviousData: true,
      enabled: !!couponIds.length && enabled,
    },
  });

  return {
    data: [...(data || [])]?.reverse(),
    ...props,
  };
};

export const useCouponDownloadAllMutation = () => {
  const { mutateAsync } = useOAIMutation({
    method: 'post',
    mutationKey: '/api/market-place/v1/coupon/download/issue',
  });
  return mutateAsync;
};

export const useCouponDownloadMutation = () => {
  const { mutateAsync } = useOAIMutation({
    method: 'post',
    mutationKey: '/api/market-place/v1/coupon/download/{couponId}/issue',
  });
  return mutateAsync;
};

export const usePointCouponListQuery = () => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/coupon/point',
    queryOptions: {
      keepPreviousData: true,
    },
  });
};

export const usePointCouponIssueMutation = () => {
  return useOAIMutation({
    method: 'post',
    mutationKey: '/api/market-place/v1/coupon/point/{couponId}/issue',
  });
};

export const useCouponDetail = (couponId?: number) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/coupon/{couponId}',
    variables: {
      couponId,
      // FIXME - 개발을 위한 임시
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any,
    queryOptions: {
      enabled: !!couponId,
    },
  });
};
